<div [closeOnOutSide]="isMenuOpen" (clickedOutside)="onClick()" class="relative inline-block text-left">
  <button #toggleButton (click)="toggleMenu($event)" type="button"
    class="z-10 inline-flex justify-center w-full rounded-md border border-gray-400 shadow-sm px-4 py-1 outline-none bg-white  font-medium text-gray-700 focus:outline-none focus:border-primary">
    <fa-icon [icon]="faIconComments" class="text-gray-700"></fa-icon>
  </button>
  <div *ngIf="isMenuOpen" class="z-20 origin-top-right absolute right-0 mt-2 w-64 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
    <div class="py-1 text-left">
      <div *ngFor="let action of actions" class="z-50">
        <div (click)="chapterActionEvent.emit(action.type); isMenuOpen = false"
          [ngStyle]="{'display': chapter.status === 'PUBLISHED' && action.type === 'delete' ? 'none' : 'block'}"
          class="block px-4 py-2 cursor-pointer  text-gray-600 hover:bg-gray-100 hover:text-gray-900">
          <span class=" text-gray-500 mr-2">
            <fa-icon [icon]="action.icon"></fa-icon>
          </span>
          {{action.name | titlecase}}
        </div>
      </div>
    </div>
    <div *ngIf="previewLink.length !== 0 " class="py-2 relative">
      <div class="flex">
        <label class="block px-4 py-1  text-gray-700" role="menuitem">Liên kết bên ngoài
          <a target="_blank" [href]="previewLink.join('/')" class="block py-2 text-xs text-primary cursor-pointer" role="menuitem">
            {{ previewLink.join('/') }}
          </a>
        </label>
      </div>
      <div class="absolute right-4 top-4">
        <button [copy-clipboard]="previewLink.join('/')" (click)="isMenuOpen = false"
          class=" md:text-xs text-white bg-gray-400 inline-block text-right cursor-pointer rounded-sm border-primary focus:shadow-outline focus:outline-none px-2 py-1 hover:bg-primary"
          type="button">
          Copy
        </button>
      </div>
    </div>
  </div>
</div>